export const formatDeliverooStatus = (status) => {
  if (status === 'placed') {
    return 'Reçue';
  } else if (status === 'accepted') {
    return 'Acceptée';
  } else if (status === 'confirmed') {
    return 'Confirmée';
  } else if (status === 'rejected') {
    return 'Refusée';
  } else if (status === 'canceled') {
    return 'Annulée';
  }
  return status || '-';
};

// Statuts du livreur Deliveroo (spec 008, registre L21). `rider_in_transit`
// est le dernier signal : le livreur a la commande — Deliveroo n'annonce
// jamais la livraison elle-même.
const RIDER_STATUS_LABELS = {
  rider_assigned: 'Livreur assigné',
  rider_arrived: 'Livreur à proximité',
  rider_confirmed_at_restaurant: 'Livreur arrivé',
  rider_checked_in: 'Livreur sur place',
  rider_in_transit: 'En livraison',
  rider_unassigned: 'Livreur retiré',
};

export const RIDER_STATUS_IN_TRANSIT = 'rider_in_transit';

export const formatRiderStatus = (status) => RIDER_STATUS_LABELS[status] || status || '-';

// Le numéro seul : un `contact_number` Deliveroo peut porter le code du pont
// entre parenthèses, qui ne doit pas se fondre dans les chiffres.
const phoneDigits = (raw) => String(raw || '').split('(')[0].replace(/\D/g, '');

// Numéros Deliveroo : chiffres internationaux sans « + » (« 33175858369 »,
// production 2026-09-28). Un numéro français s'affiche groupé par deux.
export const formatRiderPhone = (raw) => {
  const digits = phoneDigits(raw);
  if (!digits) {
    return null;
  }
  if (digits.startsWith('33') && digits.length === 11) {
    const national = digits.slice(2);
    return `+33 ${national[0]} ${national.slice(1).match(/.{2}/g).join(' ')}`;
  }
  return `+${digits}`;
};

// Lien d'appel : la virgule marque une pause, puis le téléphone compose le
// code du pont tout seul.
export const riderPhoneHref = (raw, code) => {
  const digits = phoneDigits(raw);
  if (!digits) {
    return null;
  }
  return code ? `tel:+${digits},${code}` : `tel:+${digits}`;
};
